import { PhotoChecklistConfig, QuickAccessStrategy } from './form';

/**
 * Enum representing the different types of steps in the questionnaire flow
 */
export enum StepComponentType {
    BEFORE_UPLOAD = 'BEFORE_UPLOAD',
    QUESTIONNAIRE = 'QUESTIONNAIRE',
    AFTER_UPLOAD = 'AFTER_UPLOAD',
    WARNING_INFO = 'WARNING_INFO',
}

/**
 * Enum representing the different upload component variants
 */
export enum UploadVariant {
    GUIDED = 'GUIDED',
    STANDARD = 'STANDARD',
}

/**
 * Enum representing the different condition operators for step visibility
 */
export enum ConditionOperator {
    EXISTS = 'EXISTS',
    NOT_EXISTS = 'NOT_EXISTS',
    EQUALS = 'EQUALS',
    NOT_EQUALS = 'NOT_EQUALS',
    CONTAINS = 'CONTAINS',
    NOT_CONTAINS = 'NOT_CONTAINS',
    GREATER_THAN = 'GREATER_THAN',
    LESS_THAN = 'LESS_THAN',
}

/**
 * Interface defining a condition for step visibility
 */
export interface StepCondition {
    field: string; // Dot notation path to the field (e.g., 'mold.remarks', 'status', 'mold.hotRunner')
    operator: ConditionOperator;
    value?: any; // Required for operators like EQUALS, CONTAINS, etc.
}

/**
 * Interface defining multiple conditions with logical operators and nested groups
 */
export interface StepVisibilityCondition {
    conditions?: StepCondition[];
    conditionGroups?: StepVisibilityCondition[];
    logicalOperator?: 'AND' | 'OR'; // Default is 'AND'
}

/**
 * Interface defining the structure of a step configuration
 */
export interface StepConfig {
    id: number;
    titleSuffix: string;
    componentType: StepComponentType;
    uploadVariant?: UploadVariant;
    visibilityCondition?: StepVisibilityCondition; // Condition to determine if step should be shown
    props?: {
        prefix?: string;
        coreTag?: string;
        cavityTag?: string;
        submitButtonLabel?: string;
        photoItems?: string[]; // Array of photo item IDs to include (without prefix)
        photoChecklistConfig?: PhotoChecklistConfig;
        questionnaireRemarks?: string[]; // Array of description strings for the questionnaire
    };
    quickAccessStrategy?: QuickAccessStrategy;
}
